var ReasonCodeCollection = require('./collection'),
    fvChannel = require('glRadio').channel('FV'),
    _ = require('underscore'),
    CaseInsensitiveCompare = require('../util').caseInsensitiveCompare;



/**
 * Collection used to populate the list or reason codes available to select.
 * Want a different comparator than shape ( which needs to be in order to derives unique key )
 * Now only used for the sort/comparator -- could optimize, change, below.
 */


var MAX_REMEMBERED_REASON_CODES_COUNTS = 5;


module.exports = ReasonCodeCollection.extend({

    /**
     * Perhaps could make more efficient but this seems ok for now:
     * - we only never add to these and don't need comparator -- so there's a faster way
     * - only called on open of dialogs and initial print of find and redact ones ( we don't destroy on re-open )
     * - could call sort from the views
     * - could leave comparator and create a constructor caching getAppliedReasonCodeCounts()
     * - perhaps a getSortedModels/function for printing
     * - on insertion of the models could freq-used codes alpha-numerically, then just add the other models to them on init
     * - now it's only used for the comparator, which we don't need
     * Now done on here since used in multiple views -- *** when consolidate, could just sort in the view ( no codes are added ) ***
     * Could put Non-Responsive at the top for full page redactions, though I don't think necessary ( esp when combo with Chosen )
     */

    comparator: function( a, b ) {

        // Perf boost would be caching for one sort trip -- but it's not very slow
        var appliedReasonCodeCounts =
            fvChannel.request('localStorage').getAppliedReasonCodeCounts();

        var aCode = a.get('code');
        var bCode = b.get('code');

        if ( !appliedReasonCodeCounts ) {
            return CaseInsensitiveCompare( aCode, bCode );
        }

        // area for caching ... TAKING THE TOP 5 HERE WE NEED TO SORT ON THE WAY IN TO MAKE CONSISTENT ( alpha too ) or each time here
        appliedReasonCodeCounts = appliedReasonCodeCounts.slice( 0, MAX_REMEMBERED_REASON_CODES_COUNTS );

        // Potential area for optimization; could store locally if store locally in array ( but this is minimal )
        var aInMostUsed = _.findWhere( appliedReasonCodeCounts, { code: aCode } );
        var bInMostUsed =  _.findWhere( appliedReasonCodeCounts, { code: bCode } );

        if ( !aInMostUsed && !bInMostUsed ) {

           return CaseInsensitiveCompare( aCode, bCode );

        }

        else if ( aInMostUsed && ! bInMostUsed ) {
            return -1;
        }

        else if ( bInMostUsed && !aInMostUsed ) {
            return 1;
        }

        else if ( aInMostUsed && bInMostUsed ) {

            return this.mostUsedCodeCountComparator( aInMostUsed, bInMostUsed );

        }


    },

    /**
     * Sorts {code:counts} used in local storage,
     * as well as when comparing those in the comparator above to populate dropdown.
     * See above notes -- not the most efficient;  look at better method when consolidate
     * redactionProperty dialogs.
     * Sort by count, then alpha-numeric.
     * Storing on here now for convenience.
     */
    mostUsedCodeCountComparator: function( aCodeCount, bCodeCount ) {

        var aCount = aCodeCount.count,
            bCount = bCodeCount.count;

        if ( aCount > bCount ) {

            return -1;

        } else if ( aCount < bCount ) {

            return 1;

        } else {

            return CaseInsensitiveCompare( aCodeCount.code, bCodeCount.code );

        }


    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/reasonCodes/shapeAvailableReasonCodes.js
 ** module id = 79
 ** module chunks = 0
 **/